import { useEffect } from "react";
import api from "@/lib/api";
import FinanceSettlementLegacy from "./FinanceSettlementLegacy";

function enhanceMissingButton(button) {
  if (!button || button.dataset.xlsxEnhanced === "1") return;
  button.dataset.xlsxEnhanced = "1";
  button.textContent = "Download Missing (.xlsx)";
  button.addEventListener("click", async (event) => {
    event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
    const input = document.querySelector('input[data-testid="settle-file"]');
    const file = input?.files?.[0];
    if (!file) { window.alert("Pilih file settlement terlebih dahulu."); return; }
    const old = button.textContent; button.disabled = true; button.textContent = "Menyiapkan XLSX…";
    try {
      const fd = new FormData(); fd.append("file", file);
      const res = await api.post("/marketplace/settlement/missing-receivable/export-xlsx", fd, { responseType: "blob" });
      const blob = new Blob([res.data], {type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      const url = window.URL.createObjectURL(blob); const a = document.createElement("a");
      a.href = url; a.download = "missing_receivable_orders.xlsx"; document.body.appendChild(a); a.click(); a.remove(); window.URL.revokeObjectURL(url);
    } catch (e) { window.alert(e?.response?.data?.detail || "Export Missing Receivable XLSX gagal."); }
    finally { button.disabled = false; button.textContent = old; }
  }, true);
}

function parseRupiah(text) {
  const normalized = String(text || "").replace(/[^0-9-]/g, "");
  const value = Number(normalized);
  return Number.isFinite(value) ? value : 0;
}

function formatFeeRate(gross, fee) {
  if (!(gross > 0)) return "-";
  const rate = (Math.abs(fee) / gross) * 100;
  return `${rate.toLocaleString("id-ID", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
}

function enhanceFeeRateTable() {
  const table = document.querySelector('[data-testid="settlements-table"]');
  if (!table) return;

  const headerRow = table.querySelector("thead tr");
  if (headerRow && !headerRow.querySelector('[data-fee-rate-header="1"]')) {
    const headers = Array.from(headerRow.children);
    const feeHeaderIndex = headers.findIndex((th) => th.textContent?.trim() === "Fee");
    if (feeHeaderIndex >= 0) {
      const th = document.createElement("th");
      th.textContent = "Fee %";
      th.dataset.feeRateHeader = "1";
      const feeHeader = headers[feeHeaderIndex];
      feeHeader.parentNode.insertBefore(th, feeHeader.nextSibling);
    }
  }

  const emptyCell = table.querySelector('tbody td[colspan="12"]');
  if (emptyCell) emptyCell.colSpan = 13;

  table.querySelectorAll("tbody tr").forEach((row) => {
    if (row.querySelector('[data-fee-rate-cell="1"]')) return;
    const cells = Array.from(row.children);
    if (cells.length < 12) return;

    const gross = parseRupiah(cells[5]?.textContent);
    const fee = parseRupiah(cells[6]?.textContent);
    const td = document.createElement("td");
    td.className = "mono";
    td.dataset.feeRateCell = "1";
    td.textContent = formatFeeRate(gross, fee);
    row.insertBefore(td, cells[7] || null);
  });
}

export default function FinanceSettlement() {
  useEffect(() => {
    const run = () => {
      enhanceMissingButton(document.querySelector('[data-testid="settle-download-missing-btn"]'));
      enhanceFeeRateTable();
    };
    run();
    const root = document.querySelector("main.content") || document.body;
    const obs = new MutationObserver(run);
    obs.observe(root, {childList:true, subtree:true});
    return () => obs.disconnect();
  }, []);
  return <FinanceSettlementLegacy />;
}
